<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="showSaveBar ? footerTemplate : undefined"></prox-main>
<ng-template #bodyTemplate>
  <div *ngIf="isPageReady && entities" class="flex flex-col h-full">
    <div class="qb-list-actions items-start">
      <div class="flex flex-col gap-1">
        <div class="flex gap-2">
          <p-button (onClick)="onAddPo(false)" label="Add Purchase Order" size="small" icon="pi pi-plus"
            [disabled]="isAddDisabled()"></p-button>
          <p-button (onClick)="onAddPo(true)" size="small" label="Add Parent Purchase Order" icon="pi pi-plus"
            [disabled]="isAddDisabled()"></p-button>
        </div>
        <div class="flex items-center gap-2 mt-1">
          <p-checkbox [(ngModel)]="showInactive" [binary]="true" inputId="showInactive"
            (onChange)="onShowInactiveChange()"></p-checkbox>
          <label for="showInactive" class="text-sm text-gray-600 cursor-pointer">Show Inactive Purchase Orders</label>
        </div>
      </div>
      <span class="qb-status-message">{{statusMessage()}}</span>
      <div class="grow"></div>
      <p-button *ngIf="hasHelp" size="small" (onClick)="showHelp()" icon="pi pi-question-circle"></p-button>
    </div>
    <div class="qb-layout-grid">
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="displayedEntities"></prox-ag-grid>
    </div>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel class="mt-2" [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"
    [isReadOnly]="isAddDisabled()"></prox-save-cancel>
</ng-template>